import { useQuery } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getPayrollSummary = async ({
  month,
  year,
  companyCode,
  locationCode,
  employeeCode = 0,
  isAllCompanies = false,
  selectedCompanyCode = "",
  userId = 0,
}) => {
  console.log("isAllCompanies", isAllCompanies);
  let queryString =
    employeeCode !== 0
      ? `Month=${month}&Year=${year}&companyCode=${isAllCompanies ? selectedCompanyCode : companyCode}&LocationCode=${locationCode}&Employee=${employeeCode}`
      : `Month=${month}&Year=${year}&companyCode=${isAllCompanies ? selectedCompanyCode : companyCode}&LocationCode=${locationCode}`;
  if (isAllCompanies && userId !== 0) {
    queryString += `&UserId=${userId}`;
  }
  const { data } = await http_payroll.get(
    `${isAllCompanies ? Api_EndPoints.AllCompanies_GetMonthlyWiseSummary : Api_EndPoints.GetMonthlyWiseSummary}?${queryString}`,
  );

  return data;
};

export const usePayrollSummaryQuery = (input) => {
  const isAllCompanies = Boolean(input?.isAllCompanies);
  return useQuery({
    queryKey: [
      isAllCompanies
        ? Api_EndPoints.AllCompanies_GetMonthlyWiseSummary
        : Api_EndPoints.GetMonthlyWiseSummary,
    ],
    queryFn: () => getPayrollSummary(input),
    refetchOnWindowFocus: false,
  });
};
